module.exports = __webpack_public_path__ + "images/pro/icon-pro-events@2x-91caa203fd550a0f41df8fe522ed1b3d.png";